import "../App.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../config";

import "@fontsource/open-sans";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";

import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { toast } from "wc-toast";
import { connect } from "react-redux";
import { SetId } from "./redux/actions";

import aboutFormImage from "../new1.png";

function Free_trials({ SetId }) {
  const navigate = useNavigate();

  // ================= FORM STATES =================
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [newpass, setNewpass] = useState("");

  const [show, setShow] = useState(true);
  const [reshow, setReShow] = useState(true);
  const [shown, setShown] = useState(false);
  const [loading, setLoading] = useState(false);

  // ================= RESPONSIVE =================
  const [width, setwidth] = useState(window.innerWidth);
  const [height, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const windowSizeHandler = () => {
      setwidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", windowSizeHandler);
    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  const isMobile = width <= 900;
  const isSmallLaptop = width <= 1350 && width > 900;
  const isShortScreen = height <= 820 && !isMobile;
  const isVeryShortScreen = height <= 720 && !isMobile;

  // ================= PASSWORD RULES =================
  const [first, setFirst] = useState(false);
  const [second, setSecond] = useState(false);
  const [third, setThird] = useState(false);
  const [four, setFour] = useState(false);
  const [fifth, setFifth] = useState(false);

  function containsSpecialCharacter(str) {
    const specialCharsRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/;
    return specialCharsRegex.test(str);
  }

  function hasLowerCase(str) {
    return str.toUpperCase() !== str;
  }

  function hasUpperCase(str) {
    return str.toLowerCase() !== str;
  }

  useEffect(() => {
    if (
      pass.includes(0) ||
      pass.includes(1) ||
      pass.includes(2) ||
      pass.includes(3) ||
      pass.includes(4) ||
      pass.includes(5) ||
      pass.includes(6) ||
      pass.includes(7) ||
      pass.includes(8) ||
      pass.includes(9)
    ) {
      setFour(true);
    } else {
      setFour(false);
    }

    if (hasLowerCase(pass)) {
      setThird(true);
    } else {
      setThird(false);
    }

    if (hasUpperCase(pass)) {
      setSecond(true);
    } else {
      setSecond(false);
    }

    if (pass.length >= 7) {
      setFirst(true);
    } else {
      setFirst(false);
    }

    if (containsSpecialCharacter(pass)) {
      setFifth(true);
    } else {
      setFifth(false);
    }
  }, [pass]);

  const isValidEmail = (emailValue) => {
    if (emailValue === "") return true;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(emailValue);
  };

  // ================= FIREBASE AUTH =================
  async function createUserInFirebase(userEmail, userPassword) {
    try {
      const result = await auth.createUserWithEmailAndPassword(
        userEmail,
        userPassword
      );

      if (result) {
        return true;
      }

      toast.error("Incorrect email or password. Please try again.");
      return false;
    } catch (error) {
      console.error("Error creating user:", error);

      if (String(error?.message || "").includes("already in use")) {
        toast.error("Email already in use. Please try another email.");
      } else if (String(error?.message || "").includes("password")) {
        toast.error("Password is too weak. Please try another password.");
      } else {
        toast.error("Email is invalid. Please try again.");
      }

      return false;
    }
  }

  const SERVER_BASE_URL = "https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app";

  async function syncMailchimpNewClient({ email, firstName, lastName }) {
    try {
      const response = await fetch(`${SERVER_BASE_URL}/mailchimp/new-client`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          firstName,
          lastName,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.log("Mailchimp new client sync failed:", data);
        return false;
      }

      console.log("Mailchimp new client synced:", data);
      return true;
    } catch (error) {
      console.log("Mailchimp new client sync error:", error);
      return false;
    }
  }

  // ================= REGISTER FUNCTION =================
  async function Sign_up_Function() {
    const cleanFirstName = firstName.trim();
    const cleanLastName = lastName.trim();
    const cleanEmail = email.trim().toLowerCase();
    const cleanPassword = pass.trim();
    const cleanConfirmPassword = newpass.trim();
    const fullName = `${cleanFirstName} ${cleanLastName}`.trim();

    if (!cleanFirstName) {
      toast.error("Please enter first name.");
      return;
    }

    if (!cleanLastName) {
      toast.error("Please enter last name.");
      return;
    }

    if (!cleanEmail) {
      toast.error("Please enter email address.");
      return;
    }

    if (!isValidEmail(cleanEmail)) {
      toast.error("Please complete your email address.");
      return;
    }

    if (!cleanPassword) {
      toast.error("Please enter password.");
      return;
    }

    if (!cleanConfirmPassword) {
      toast.error("Please confirm password.");
      return;
    }

    if (cleanPassword !== cleanConfirmPassword) {
      toast.error("Password does not match.");
      return;
    }

    if (!(first && second && third && four && fifth)) {
      toast.error("Password is not strong.");
      return;
    }

    try {
      setLoading(true);

      const res = await createUserInFirebase(cleanEmail, cleanPassword);

      if (res !== true) {
        setLoading(false);
        return;
      }

      await auth.signInWithEmailAndPassword(
        "n.joy@boomsoftware.co.uk",
        "2103199j"
      );

      const ID = new Date().getTime();

      const obj = {
        Email: cleanEmail,
        Name: fullName,
        Password: cleanPassword,
        id: ID,
        device_no: 0,
        FirstName: cleanFirstName,
        LastName: cleanLastName,
      };

      await db.ref("Sign_up").child(String(ID)).set(obj);

      await syncMailchimpNewClient({
        email: cleanEmail,
        firstName: cleanFirstName,
        lastName: cleanLastName,
      });

      const folder_obj = {
        ID: new Date().getTime(),
        name: "vnwchgf",
      };

      await db
        .ref("userdb")
        .child(String(ID))
        .child("folder")
        .child(String(folder_obj.ID))
        .set(folder_obj);

      localStorage.setItem("display", JSON.stringify(obj));
      SetId(obj);

      toast.success("Account created successfully.");

      setTimeout(() => {
        navigate("/");
      }, 700);
    } catch (error) {
      console.error("Signup error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  // ================= UI HELPERS =================
  const cardRadius = isMobile ? 18 : 18;

  const inputHeight = isVeryShortScreen
    ? 46
    : isShortScreen
      ? 48
      : isMobile
        ? 54
        : 58;

  const formGap = isVeryShortScreen
    ? 11
    : isShortScreen
      ? 13
      : isMobile
        ? 16
        : 24;

  const fieldBg = "#1E1207";
  const fieldBorder = "1px solid rgba(247,148,29,0.35)";
  const fieldText = "#EDEDED";
  const fieldPlaceholder = "#F7941D";

  const inputStyle = {
    width: "100%",
    height: inputHeight,
    borderRadius: 9,
    background: fieldBg,
    border: fieldBorder,
    outline: "none",
    paddingLeft: isMobile ? 16 : 22,
    paddingRight: isMobile ? 16 : 22,
    color: fieldText,
    fontSize: isVeryShortScreen ? 14 : isShortScreen ? 15 : isMobile ? 16 : 18,
    fontWeight: 400,
    fontFamily: "Open Sans",
    boxSizing: "border-box",
  };

  const passwordInputWrapStyle = {
    width: "100%",
    height: inputHeight,
    borderRadius: 9,
    background: fieldBg,
    border: fieldBorder,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    paddingLeft: isMobile ? 16 : 22,
    paddingRight: isMobile ? 14 : 18,
  };

  const passwordInputStyle = {
    width: "100%",
    height: "100%",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    color: fieldText,
    fontSize: isVeryShortScreen ? 14 : isShortScreen ? 15 : isMobile ? 16 : 18,
    fontWeight: 400,
    fontFamily: "Open Sans",
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#04080D",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile
          ? "18px"
          : isVeryShortScreen
            ? "10px 16px"
            : "14px 18px",
        boxSizing: "border-box",
        overflow: isMobile ? "auto" : "hidden",
      }}
    >
      <wc-toast
        position="top-center"
        style={{
          position: "fixed",
          top: 18,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 999999,
        }}
      ></wc-toast>

      <style>
        {`
          input::placeholder {
            color: ${fieldPlaceholder};
            opacity: 1;
          }

          input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus {
            -webkit-text-fill-color: ${fieldText};
            -webkit-box-shadow: 0 0 0px 1000px ${fieldBg} inset;
            transition: background-color 5000s ease-in-out 0s;
          }
        `}
      </style>

      <div
        style={{
          width: "100%",
          maxWidth: isShortScreen ? 1450 : 1600,
          height: isMobile ? "auto" : "calc(100vh - 24px)",
          maxHeight: isMobile ? "none" : 930,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1.16fr 0.84fr",
          gap: isMobile ? 0 : isSmallLaptop ? 36 : 70,
          alignItems: "stretch",
        }}
      >
        {/* ================= LEFT IMAGE PANEL ================= */}
        <div
          style={{
            display: isMobile ? "none" : "block",
            position: "relative",
            height: "100%",
            minHeight: isVeryShortScreen ? 520 : isShortScreen ? 560 : 620,
            borderRadius: cardRadius,
            overflow: "hidden",
            background: "#080808",
          }}
        >
          <img
            src={aboutFormImage}
            alt="Boom Display"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "left top",
              display: "block",
              position: "absolute",
              inset: 0,
            }}
          />
        </div>

        {/* ================= RIGHT FORM PANEL ================= */}
        <div
          style={{
            width: "100%",
            height: isMobile ? "auto" : "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingTop: isMobile
              ? 0
              : isVeryShortScreen
                ? 4
                : isShortScreen
                  ? 6
                  : 20,
            paddingBottom: isMobile
              ? 0
              : isVeryShortScreen
                ? 4
                : isShortScreen
                  ? 6
                  : 20,
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: isShortScreen ? 500 : 540,
              marginLeft: isMobile ? 0 : "auto",
              marginRight: isMobile ? 0 : "auto",
            }}
          >
            {/* ================= BACK TO WEBSITE BUTTON ================= */}
            <div
              onClick={() => {
                window.location.href = "https://display.boomsoftware.co.uk/";
              }}
              style={{
                alignSelf: "flex-start",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: isVeryShortScreen
                  ? 8
                  : isShortScreen
                    ? 10
                    : isMobile
                      ? 18
                      : 22,
                padding: isVeryShortScreen
                  ? "8px 13px"
                  : isMobile
                    ? "10px 14px"
                    : "11px 16px",
                borderRadius: 999,
                border: "1px solid rgba(247,148,29,0.35)",
                background: "rgba(247,148,29,0.10)",
                color: "#F7941D",
                fontSize: isVeryShortScreen ? 13 : isMobile ? 14 : 15,
                fontFamily: "Open Sans",
                fontWeight: 700,
                cursor: "pointer",
                boxSizing: "border-box",
                userSelect: "none",
              }}
            >
              ← Back to website
            </div>

            {/* ================= HEADER TEXT ================= */}
            <div
              style={{
                color: "#D8D8D8",
                fontSize: isVeryShortScreen
                  ? 14
                  : isShortScreen
                    ? 15
                    : isMobile
                      ? 16
                      : 18,
                fontWeight: 400,
                fontFamily: "Open Sans",
                lineHeight: isVeryShortScreen ? "21px" : "26px",
              }}
            >
              Get{" "}
              <span style={{ color: "#F7941D", fontWeight: 700 }}>
                7 days
              </span>{" "}
              free trial.
            </div>

            <div
              style={{
                marginTop: isVeryShortScreen ? 5 : isShortScreen ? 7 : 12,
                color: "#FFFFFF",
                fontSize: isVeryShortScreen
                  ? 28
                  : isShortScreen
                    ? 32
                    : isMobile
                      ? 34
                      : 42,
                fontWeight: 700,
                fontFamily: "Open Sans",
                lineHeight: isVeryShortScreen
                  ? "34px"
                  : isShortScreen
                    ? "39px"
                    : isMobile
                      ? "42px"
                      : "52px",
              }}
            >
              Hi there, 👋
            </div>

            <div
              style={{
                marginTop: isVeryShortScreen ? 5 : isShortScreen ? 7 : 10,
                color: "#9B94A6",
                fontSize: isVeryShortScreen
                  ? 14
                  : isShortScreen
                    ? 15
                    : isMobile
                      ? 16
                      : 18,
                fontWeight: 400,
                fontFamily: "Open Sans",
                lineHeight: isVeryShortScreen
                  ? "22px"
                  : isShortScreen
                    ? "24px"
                    : isMobile
                      ? "28px"
                      : "32px",
              }}
            >
              Create your account and start your 7-day free trial.
            </div>

            {/* ================= FORM ================= */}
            <div
              style={{
                width: "100%",
                marginTop: isVeryShortScreen
                  ? 14
                  : isShortScreen
                    ? 16
                    : isMobile
                      ? 24
                      : 30,
                display: "flex",
                flexDirection: "column",
                gap: formGap,
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gap: isVeryShortScreen
                    ? 10
                    : isShortScreen
                      ? 12
                      : isMobile
                        ? 14
                        : 16,
                }}
              >
                <input
                  placeholder="First Name"
                  style={inputStyle}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />

                <input
                  placeholder="Last Name"
                  style={inputStyle}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <input
                placeholder="Your Email"
                style={inputStyle}
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <div style={passwordInputWrapStyle}>
                <input
                  placeholder="Password"
                  style={passwordInputStyle}
                  type={show ? "password" : "text"}
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  onFocus={() => setShown(true)}
                  onBlur={() => setShown(false)}
                />

                <div
                  onClick={() => setShow(!show)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 10,
                    flexShrink: 0,
                  }}
                >
                  {show ? (
                    <FaRegEyeSlash
                      size={isVeryShortScreen ? 18 : 20}
                      color="#F7941D"
                    />
                  ) : (
                    <FaRegEye
                      size={isVeryShortScreen ? 18 : 20}
                      color="#F7941D"
                    />
                  )}
                </div>
              </div>

              {shown ? (
                <div
                  style={{
                    width: "100%",
                    marginTop: isVeryShortScreen ? -5 : -8,
                    borderRadius: 10,
                    backgroundColor: "rgba(247,148,29,0.10)",
                    border: "1px solid rgba(247,148,29,0.25)",
                    padding: isVeryShortScreen ? "8px 12px" : "12px 14px",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    gap: isVeryShortScreen ? 4 : 7,
                  }}
                >
                  <div
                    style={{
                      color: first ? "#D8D8D8" : "#ff6b6b",
                      fontSize: isVeryShortScreen ? 11 : 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must be at least 7 characters
                  </div>

                  <div
                    style={{
                      color: second ? "#D8D8D8" : "#ff6b6b",
                      fontSize: isVeryShortScreen ? 11 : 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 upper case character
                  </div>

                  <div
                    style={{
                      color: third ? "#D8D8D8" : "#ff6b6b",
                      fontSize: isVeryShortScreen ? 11 : 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 lower case character
                  </div>

                  <div
                    style={{
                      color: four ? "#D8D8D8" : "#ff6b6b",
                      fontSize: isVeryShortScreen ? 11 : 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 numeric character
                  </div>

                  <div
                    style={{
                      color: fifth ? "#D8D8D8" : "#ff6b6b",
                      fontSize: isVeryShortScreen ? 11 : 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 special character
                  </div>
                </div>
              ) : null}

              <div style={passwordInputWrapStyle}>
                <input
                  placeholder="Confirm Password"
                  style={passwordInputStyle}
                  type={reshow ? "password" : "text"}
                  value={newpass}
                  onChange={(e) => setNewpass(e.target.value)}
                />

                <div
                  onClick={() => setReShow(!reshow)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 10,
                    flexShrink: 0,
                  }}
                >
                  {reshow ? (
                    <FaRegEyeSlash
                      size={isVeryShortScreen ? 18 : 20}
                      color="#F7941D"
                    />
                  ) : (
                    <FaRegEye
                      size={isVeryShortScreen ? 18 : 20}
                      color="#F7941D"
                    />
                  )}
                </div>
              </div>

              {newpass !== "" && pass !== newpass ? (
                <div
                  style={{
                    width: "100%",
                    marginTop: isVeryShortScreen ? -6 : -10,
                    padding: isVeryShortScreen ? "7px 11px" : "9px 13px",
                    borderRadius: 9,
                    background: "rgba(247,148,29,0.14)",
                    color: "#F7941D",
                    fontSize: isVeryShortScreen ? 11 : 13,
                    fontFamily: "Open Sans",
                    boxSizing: "border-box",
                  }}
                >
                  Password does not match.
                </div>
              ) : null}
            </div>

            {/* ================= TERMS TEXT ================= */}
            <div
              style={{
                width: "100%",
                marginTop: isVeryShortScreen
                  ? 14
                  : isShortScreen
                    ? 16
                    : 26,
                color: "#D8D8D8",
                fontSize: isVeryShortScreen
                  ? 11
                  : isShortScreen
                    ? 12
                    : isMobile
                      ? 13
                      : 14,
                lineHeight: isVeryShortScreen
                  ? "17px"
                  : isShortScreen
                    ? "19px"
                    : "22px",
                fontFamily: "Open Sans",
              }}
            >
              By registering, you confirm that you’ve read and accepted our{" "}
              <span
                onClick={() => {
                  const win = window.open(
                    "https://display.boomsoftware.co.uk/T",
                    "_blank"
                  );
                  if (win) win.focus();
                }}
                style={{
                  color: "#F7941D",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Terms of Use
              </span>{" "}
              and{" "}
              <span
                onClick={() => {
                  const win = window.open(
                    "https://display.boomsoftware.co.uk/P",
                    "_blank"
                  );
                  if (win) win.focus();
                }}
                style={{
                  color: "#F7941D",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Privacy Policy
              </span>
              .
            </div>

            {/* ================= REGISTER BUTTON ================= */}
            <button
              onClick={Sign_up_Function}
              disabled={loading}
              style={{
                width: "100%",
                height: isVeryShortScreen
                  ? 48
                  : isShortScreen
                    ? 52
                    : isMobile
                      ? 58
                      : 62,
                marginTop: isVeryShortScreen
                  ? 16
                  : isShortScreen
                    ? 20
                    : 32,
                border: "none",
                borderRadius: 9,
                backgroundColor: loading ? "rgba(247,148,29,0.55)" : "#F7941D",
                color: "#000000",
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: isVeryShortScreen
                  ? 19
                  : isShortScreen
                    ? 21
                    : isMobile
                      ? 22
                      : 27,
                cursor: loading ? "not-allowed" : "pointer",
                boxSizing: "border-box",
              }}
            >
              {loading ? "Registering..." : "Register"}
            </button>

            {/* ================= SIGN IN TEXT ================= */}
            <div
              style={{
                width: "100%",
                marginTop: isVeryShortScreen
                  ? 14
                  : isShortScreen
                    ? 16
                    : 28,
                textAlign: "center",
                color: "#D8D8D8",
                fontSize: isVeryShortScreen
                  ? 14
                  : isShortScreen
                    ? 15
                    : isMobile
                      ? 16
                      : 18,
                fontFamily: "Open Sans",
                fontWeight: 400,
              }}
            >
              Already have an account?{" "}
              <span
                onClick={() => navigate("/")}
                style={{
                  color: "#26A7DF",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                Sign In
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, { SetId })(Free_trials);

// https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app